import React from 'react';
import { useTranslation } from 'react-i18next';

import { BillingPaymentsProvider } from './Context';

import { TableBillingScreen } from './Components/Table';
import { PageHeadline } from '../../../components/atoms';

const BillingScreen: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <BillingPaymentsProvider>
        <div className="mb-6">
          <PageHeadline
            title={t('labels.lblBilling')}
            subtitle={t('billingPayments.billingPaymentsSubtitle')}
          />
        </div>

        <div className="mt-6">
          <TableBillingScreen />
        </div>
      </BillingPaymentsProvider>
    </>
  );
};

export { BillingScreen };
